class LocalStorageHandler {
    constructor(props) {
        this.props = props;
        this.local = this.getAllItems();
    }

    setStateCallback(prevState, key, value) {
        if(this.props?.setStateCallback) {
            this.props.setStateCallback((prevState) => {
                return {
                    ...prevState,
                    [key]: value
                }
            });
        }
    }

    setItem(key, value) {
        localStorage.setItem(key, value);
    }

    getItem(key) {
        return localStorage.getItem(key);
    }

    getAllItems() {
        let items = {};
        for (let i = 0; i < localStorage.length; i++) {
            let key = localStorage.key(i);
            items[key] = localStorage.getItem(key);
        }
        return items;
    }
}

export default LocalStorageHandler;